import { createAsyncActionTypes } from '@mews/framework/redux';

const FETCH_PAYMENT_CARDS = 'FETCH_PAYMENT_CARDS';
export const [FETCH_PAYMENT_CARDS_STARTED, FETCH_PAYMENT_CARDS_SUCCEEDED, FETCH_PAYMENT_CARDS_FAILED] =
    createAsyncActionTypes(FETCH_PAYMENT_CARDS);
